export default __webpack_public_path__ + "static/media/6.af05fae7.jpg";